import React from "react";
import BatchReportsPage from "./BatchReportsPage";

export default function BatchReportsPublishedPage() {
  return (
    <BatchReportsPage title="Tareas Publicadas" releasedForOperator />
  );
}
